export default __webpack_public_path__ + "static/media/etienne.0bd64a83.pdf";